<template>
  <div class="animated fadeIn">
    <form @submit.stop.prevent="post()">
      <b-row>
        <b-col sm="12">
          <b-card id="card-relatorio" 
            :bg-variant="isDark ? 'dark' : 'white'" 
            :text-variant="isDark ? 'light' : 'dark'"
            :footer-bg-variant="isDark ? 'dark' : 'light'">
            
            <div slot="header" class="d-flex align-items-center justify-content-between" :class="isDark ? 'bg-dark border-secondary' : ''">
                <div>
                  <i class='fa fa-book mr-2'></i><strong>Relatório do Livro Caixa</strong>
                </div>
            </div>

            <!-- Seção 1: Filtros de Conta -->
            <div class="section-container mb-4" :class="isDark ? 'dark-mode' : ''">
              <h6 class="section-title" :class="isDark ? 'dark-mode' : ''"><i class="fa fa-university mr-2"></i>Instituição e Conta</h6>
              <b-row>
                <b-col md="6" sm="12">
                  <b-form-group label="Banco">
                    <b-form-select v-model="registro.BANCO_ID" :options="optionsbancos" ref="combobanco" :class="isDark ? 'bg-secondary text-white border-info' : ''">
                      <template slot="first">
                        <option :value="null">-- Selecione um Banco --</option>
                      </template>
                    </b-form-select>
                  </b-form-group>
                </b-col>
                <b-col md="6" sm="12">
                  <b-form-group label="Conta">
                    <b-form-select :disabled="!registro.BANCO_ID" 
                                    v-model="registro.CONTA_ID" 
                                    :options="optionscontas" 
                                    :class="[isDark ? 'bg-secondary text-white border-info' : '', {'is-invalid': !registro.CONTA_ID && submmited }]"
                                    ref="comboconta"
                                    :required="true">
                      <template slot="first">
                        <option :value="null">-- Selecione uma Conta --</option>
                      </template>
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>

            <!-- Seção 2: Período -->
            <div class="section-container mb-4" :class="isDark ? 'dark-mode' : ''">
              <h6 class="section-title" :class="isDark ? 'dark-mode' : ''"><i class="fa fa-calendar mr-2"></i>Período do Relatório</h6>
              <b-row>
                <b-col md="6" sm="12">
                  <b-form-group label="Data Início">
                    <cec-input-data id="dt1" v-model="registro.DT1" :state="registro.DT1 ? null : false" />
                  </b-form-group>
                </b-col>
                <b-col md="6" sm="12">
                  <b-form-group label="Data Fim">
                    <cec-input-data id="dt2" v-model="registro.DT2" :state="registro.DT2 ? null : false" />
                  </b-form-group>
                </b-col>
              </b-row>
            </div>

            <div slot="footer" class="p-3" :class="isDark ? 'bg-dark border-top border-secondary' : 'bg-light'">
              <b-row class="justify-content-center">
                <b-col md="4" sm="12">
                  <vue-button-spinner block size="lg" type="submit" variant="primary" :isLoading="isLoading" :disabled="isLoading" :status="status" class="btn-generate shadow-sm">
                    <i class="fa fa-file-pdf-o mr-2"></i> GERAR RELATÓRIO
                  </vue-button-spinner>              
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </form>
  </div>
</template>

<script>
import VueButtonSpinner from '../../components/VueButtonSpinner.vue'
import CecInputData from '@/components/Cec/CecInputData.vue'
import moment from 'moment'

export default {
  data () {
    return {
      registro: {
        BANCO_ID: null,
        CONTA_ID: null,
        DT1: moment().format('YYYY-MM-DD'),
        DT2: moment().format('YYYY-MM-DD')
      },
      parametros: {
        nomeConta: '',
        nomeBanco: ''
      },
      isLoading: false,
      status: '',
      submmited: false,
      optionsbancos: [],
      optionscontas: []
    }
  },
  components: {
    VueButtonSpinner,
    CecInputData
  },
  computed: {
    isValid () {
      return !!this.registro.CONTA_ID && !!this.registro.BANCO_ID && !!this.registro.DT1 && !!this.registro.DT2
    },
    isDark () {
      return this.$store.getters['tema/IS_DARK']
    }
  },
  methods: {
    CONTA_IDRequerido () {
      return !!this.registro.CONTA_ID
    },
    atualizaContas () {
      this.optionscontas = []
      this.registro.CONTA_ID = null
      let uri = this.$http.defaults.baseURL.concat('api/protected/conta/listarporbanco?bancoid=' + this.registro.BANCO_ID)
      let promise = this.$http.get(uri)
      promise.then((data) => {
        if (data) {
          for (let i = 0; i < data.data.length; i++) {
            this.optionscontas.push({value: data.data[i].ID, text: data.data[i].CODIGONOME})
          }
        }
      })
    },
    verificaMovimento () {
      let dt1convertido = this.registro.DT1.replace(/(\d{4})-(\d{2})-(\d{2})/, '$2/$3/$1')
      let uri = this.$http.defaults.baseURL.concat('api/protected/conta/verificamovimento?contaid=' + this.registro.CONTA_ID +
        '&dtmov=' + dt1convertido)
      return this.$http.get(uri).then((data) => {
        return (data.data && data.data.length) ? data.data : null
      })
    },
    post () {
      this.submmited = true
      if (!this.isValid) {
        this.$toast.warn({
          title: 'Aviso',
          message: 'Por favor, preencha todos os campos obrigatórios',
          progressBar: false,
          showMethod: 'shake',
          position: 'top full width'
        })
        return
      }

      this.isLoading = true
      this.verificaMovimento()
        .then((dados) => {
          if (!dados) {
            this.$toast.warn({
              title: 'Aviso',
              message: 'Não existe caixa aberto para essa data inicial',
              progressBar: false,
              showMethod: 'shake',
              position: 'top full width'
            })
            this.isLoading = false
            return
          }
          
          this.$store.commit('controle/setAguardando', true)
          this.isLoading = true

          const params = {
            contaid: this.registro.CONTA_ID,
            dt1: this.registro.DT1,
            dt2: this.registro.DT2,
            lbempresa: window.localStorage.getItem('nomeempresa'),
            lbusuario: window.localStorage.getItem('nomeusuario'),
            lbbanco: this.getLabelFromOptions('combobanco', this.registro.BANCO_ID),
            lbconta: this.getLabelFromOptions('comboconta', this.registro.CONTA_ID)
          }

          const uri = '/api/protected/relatorios/relcaixalivro?' + new URLSearchParams(params).toString()

          this.$http.get(uri, {responseType: 'arraybuffer'})
            .then(response => {
              this.$store.commit('controle/setAguardando', false)
              this.isLoading = false
              this.$toast.success({
                title: 'Sucesso',
                message: 'Relatório Gerado com Sucesso',
                progressBar: false,
                timeOut: 3000,
                showMethod: 'shake',
                position: 'top full width'
              })
              const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}))
              window.open(url)
            })
            .catch(erro => {
              this.$store.commit('controle/setAguardando', false)
              this.isLoading = false
              this.$toast.error({
                title: 'Erro',
                message: 'Ocorreram erros ao gerar o Relatório',
                progressBar: false,
                showMethod: 'shake',
                position: 'top full width'
              })
            })
        })
    },
    getLabelFromOptions (refName, value) {
      if (!value) return ''
      const component = this.$refs[refName]
      if (component && component.options) {
        const option = component.options.find(o => o.value === value)
        return option ? option.text : ''
      }
      return ''
    }
  },
  created () {
    let uri = this.$http.defaults.baseURL.concat('api/protected/banco/listartodos')
    this.$http.get(uri).then((data) => {
      if (data) {
        this.optionsbancos = data.data.map(b => ({ value: b.ID, text: b.CODIGONOME }))
      }
    })
  },
  watch: {
    'registro.BANCO_ID': function () {
      this.atualizaContas()
    }
  }
}
</script>

<style scoped>
.section-container {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  border: 1px solid #e4e7ea;
  transition: all 0.3s ease;
}

.section-container:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.section-container.dark-mode {
  background: #2f353a;
  border-color: #434a50;
}

.section-title {
  color: #20a8d8;
  border-bottom: 1px solid #c2cfd6;
  padding-bottom: 8px;
  margin-bottom: 20px;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 0.85rem;
  letter-spacing: 1px;
}

.section-title.dark-mode {
  color: #63c2de;
  border-color: #434a50;
}

.btn-generate {
  font-weight: 700;
  letter-spacing: 1px;
  padding: 12px;
  transition: all 0.3s;
}

.btn-generate:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(32, 168, 216, 0.4);
}

.dark-mode .form-group label {
  color: #a4b7c1;
}

#card-relatorio {
  border-radius: 12px;
  overflow: hidden;
  border: none;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}
</style>



// WEBPACK FOOTER //
// src/views/relatorios/RelCaixaLivro.vue